import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import MiniLogo from '../../images/max-logo.png'
import { SiGnuprivacyguard } from "react-icons/si";
import { AiOutlineHome } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import { GoInfo } from "react-icons/go";
import { FaRegStar } from "react-icons/fa";
import logo from "../../images/55-logo.webp";


export function SideNavbar({ openSidenav, setOpenSidenav }) {
    const location = useLocation();
    const sidenavRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidenavRef.current && !sidenavRef.current.contains(event.target)) {
                setOpenSidenav(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setOpenSidenav]);

    return (
        <aside
            ref={sidenavRef}
            className={`sidebar-bg-responsive shadow-sm ${openSidenav ? "translate-x-0" : "-translate-x-full"
                } fixed inset-0 z-50 h-full w-72 transition-transform duration-500 delay-75 border-r-2 border-[#E4E4E41A]`}
        >
            <div className="py-6 pl-6 flex justify-between items-start">
                <Link to="/" onClick={() => setOpenSidenav(false)}>
                    <img alt="" src={MiniLogo} className="max-h-12 max-w-[180px] object-contain" />
                </Link>
                <div></div>
                <div className="text-3xl font-black text-white text-end pr-7 cursor-pointer" onClick={() => setOpenSidenav(false)}>×</div>
            </div>

            {/* Sidebar content */}
            <div className="p-4">
                <ul className="mb-4 flex flex-col gap-4 pl-2">
                    {SidebarContent.map((item) => (
                        <li
                            key={item.id}
                            className={`font-normal text-base group ${location.pathname === item.path ? "text-white" : "text-white"}`}
                            onClick={() => setOpenSidenav(false)}
                        >
                            <Link
                                to={item.path}
                                className="flex items-center justify-start gap-4"
                            >
                                <div
                                    className={`rounded-[14.3px] p-3 bg-white`}
                                >
                                    {React.cloneElement(item.icon, {
                                        className: `fill-current text-[#0F2124] group-hover:text-[#f95959]`,
                                    })}
                                </div>
                                <span
                                    className={`font-semibold text-base text-white group-hover:font-black group-hover:text-lg group-hover:text-[#0F2124]`}
                                >
                                    {item.name}
                                </span>
                            </Link>
                        </li>
                    ))}
                    <li
                        className={`font-normal text-base group`}
                        onClick={() => setOpenSidenav(false)}
                    >
                        <Link
                            to={'https://play.google.com/store/apps/details?id=app.dm.directmessage'}
                            target="_blank"
                            className="flex items-center justify-start gap-4"
                        >
                            <div
                                className={`rounded-[14.3px] p-3 bg-white`}
                            >
                                {React.cloneElement(<FaRegStar size={22} />, {
                                    className: `fill-current text-[#0F2124] group-hover:text-[#f95959]`,
                                })}
                            </div>
                            <span
                                className={`font-semibold text-base text-white group-hover:font-black group-hover:text-lg group-hover:text-[#0F2124]`}
                            >
                                Rate App
                            </span>
                        </Link>
                    </li>
                </ul>
            </div>
        </aside>
    );
}

export default SideNavbar;

const SidebarContent = [
    {
        id: 1,
        name: "Home",
        path: "/",
        icon: <AiOutlineHome size={22} />
    },
    {
        id: 2,
        name: " Help & Support",
        path: "/help",
        icon: <BiSupport size={22} />
    },
    {
        id: 3,
        name: "About Us",
        path: "/aboutus",
        icon: <GoInfo size={22} />
    },
    {
        id: 4,
        name: "Privacy Policy",
        path: "/privacypolicy",
        icon: <SiGnuprivacyguard size={22} />
    }
];